import VideoPlayer from './video-player'

export default VideoPlayer
